<div class="content">
    <h3>Aditional time spent in minutes</h3>
    <div class="example-button-row">
        <button mat-mini-fab color="primary" [ngClass]="isSelected(i) ? 'selectedbutton' : 'notSelectedbutton'"
            (click)="selectButton(i)" *ngFor="let a of fakeArray; let i=index"> {{(i+1)*5}}</button>
    </div>
    <div>
        <button class="btn btn-sm" (click)="Save()"> Save</button>
    </div>
</div>